import { c as _c } from "react/compiler-runtime";
import { getOrgRiskSignalsSpecOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';
import useSession from '@/hooks/use-session';
const useRiskSignalsGrouped = () => {
  const $ = _c(4);
  const {
    authHeaders
  } = useSession();
  let t0;
  if ($[0] !== authHeaders) {
    t0 = getOrgRiskSignalsSpecOptions({
      headers: authHeaders
    });
    $[0] = authHeaders;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      ...t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useQuery(t1);
};
export default useRiskSignalsGrouped;